import { defineComponent } from "vue";

import routes from "./AdminRouter";

import LevelTwo from "../../LevelTwo/LevelTwo.vue";

export default defineComponent({
    components: {
        LevelTwo
    },

    data() {
        return {
            router: null
        };
    },

    async mounted() {
        this.router = routes;
    }
});
